import MuiListItem, {
  type ListItemProps as MuiListItemProps,
} from '@mui/material/ListItem';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import classNames from 'classnames';
import React from 'react';

import type { Routes } from '../../../router';

import RouterLink from '../../RouterLink';
import './ListItem.scss';

export interface ListItemProps extends MuiListItemProps {
  /**
   * If provided, it will appen red error color to button
   */
  destructive?: boolean;
  to?: Routes;
}
const ListItem = React.forwardRef(
  (props: ListItemProps, ref: React.ForwardedRef<HTMLLIElement>) => {
    const otherProps = omit(props, 'children', 'destructive');

    return (
      <MuiListItem
        {...otherProps}
        className={classNames(
          'Mfw-ListItem',
          {
            'Mfw-ListItemButton--destructive': props.destructive,
          },
          props.className,
        )}
        ref={ref}
        {...(props.to ? { to: props.to } : {})}
        {...(props.to ? { LinkComponent: RouterLink } : {})}
      >
        {props.children}
      </MuiListItem>
    );
  },
);

ListItem.displayName = 'ListItem';

export default React.memo(ListItem, (prevProps, nextProps) => {
  const withoutPrevPropsChildren = omit(prevProps, 'children');
  const withoutNextPropsChildren = omit(nextProps, 'children');
  return (
    prevProps.children === nextProps.children &&
    isEqual(withoutPrevPropsChildren, withoutNextPropsChildren)
  );
});
